import { localStorageItemKeys } from '~constants/local-storage-items'
import { sessionStorageItems } from '~constants/session-storage-items'
import { Environment, environmentToggle } from './feature-toggles'

export function applyEnvironmentIndication() {
  const isDisabled =
    localStorage.getItem(
      localStorageItemKeys.retainedPostLogout.disableEnvironmentIndication,
    ) === 'true'

  if (isDisabled) return

  const isStagePreviewMode =
    sessionStorage.getItem(sessionStorageItems.stagePreviewMode) === 'true' ||
    new URLSearchParams(window.location.search).get('stagePreview') === 'true'

  const isStaging =
    environmentToggle(Environment.Stage) ||
    import.meta.env.VITE_API_URL?.includes(Environment.Stage)

  const isProduction = import.meta.env.VITE_API_URL?.includes(
    Environment.Production,
  )

  const isTest = environmentToggle(Environment.Test)

  if (isTest) {
    document.documentElement.classList.add('test-env')
  } else if (isStaging && !isStagePreviewMode) {
    document.documentElement.classList.add('staging-env')
  } else if (isProduction) {
    document.documentElement.classList.add('production-env')
  }
}
